module.exports = __webpack_public_path__ + "static/media/novo-banner.a82297e2.webp";